import { render, staticRenderFns } from "./RecipeHeader.vue?vue&type=template&id=44dcfae2&scoped=true&"
import script from "./RecipeHeader.vue?vue&type=script&lang=js&"
export * from "./RecipeHeader.vue?vue&type=script&lang=js&"
import style0 from "./RecipeHeader.vue?vue&type=style&index=0&id=44dcfae2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dcfae2",
  null
  
)

export default component.exports